import './SuggestionsInfoSection.css';
export var container = '_cpuf061-3-8-0';
export var shortcutLabel = '_cpuf063-3-8-0';
export var shortcutsGroup = '_cpuf062-3-8-0';